import { LoadingOutlined } from '@ant-design/icons'
import { Button, Modal, Spin, Tabs } from 'antd'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useState } from 'react'
import AccessControlAction from '../../components/AccessControlAction'
import { OverlayPanelWrapper } from '../../components/Overlays/OverlayPanelWrapper'
import { ACL_ACTION_TYPE } from '../../constants'
import date_format from '../../date_format'
import common_history_log from '../../enum_utils'
import utils from '../../utils'
import DiffTable from '../ListHistoryLog/DiffTable/DiffTable'
import MissionDetailAssign from '../MissionDetailPage/MissionDetailAssign'
import MissionDetailFiles from '../MissionDetailPage/MissionDetailFiles'
import MissionDetailGeneralInfo from '../MissionDetailPage/MissionDetailGeneralInfo'
import { TaskInfoListItemStyledV2 } from '../MissionDetailPage/MissionDetailPageStyled'
import MissionDetailUpdate from '../MissionDetailPage/MissionDetailUpdate'
import MissionDetailWorks from '../MissionDetailPage/MissionDetailWorks'
import MissionItemDetailUpdateModalV2 from './MissionItemDetailUpdateModalV2'

const MissionItemDetailModalV2 = props => {
  const {
    showInPageView = false,
    pageHeader = null,
    open,
    setOpen,
    taskCode,
    taskStore,
    listHistoryLogStore,
  } = props || {}
  const [isLoadingTaskDetail, setIsLoadingTaskDetail] = useState(false)
  const [taskDetail, setTaskDetail] = useState(null)

  const { list, isLoading, message } = listHistoryLogStore

  const [isUpdateMissionDetail, setIsUpdateMissionDetail] = useState(false)

  const handleGetTaskDetail = useCallback(async taskCode => {
    try {
      setIsLoadingTaskDetail(true)
      await taskStore.getTaskDetail(taskCode)
      setTaskDetail(toJS(taskStore.taskDetail))
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadingTaskDetail(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const hanhleGetListHistoryLog = useCallback(async taskCode => {
    try {
      listHistoryLogStore.getList(taskCode)
    } catch (error) {
      console.log(error)
      message.error(error?.vi || 'Đã có lỗi xảy ra')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if ((open || showInPageView) && taskCode) {
      handleGetTaskDetail(taskCode)
      hanhleGetListHistoryLog(taskCode)
    }

    return () => {
      taskStore.clearTaskDetail()
      listHistoryLogStore.clear()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, taskCode, showInPageView])

  const tabItems = [
    {
      key: '1',
      label: 'Người tham gia',
      children: (
        <>
          {taskDetail?.contentTask && (
            <MissionDetailAssign
              renderContentOnly
              leader={taskDetail.leader}
              handler={taskDetail.handler}
              combiner={taskDetail.combiner}
              capGiao={taskDetail.contentTask?.cap_giao}
            />
          )}
        </>
      ),
    },
    {
      key: '2',
      label: 'Tài liệu đính kèm',
      children: (
        <>
          {taskDetail?.contentTask && (
            <MissionDetailFiles
              renderContentOnly
              handleSetTaskDetail={setTaskDetail}
              canUpdateProgress={!!taskDetail.canUpdateProgress}
              missionId={taskCode}
              isDetailList
              files={taskDetail?.resultTask?.files || []}
              resultTask={taskDetail?.resultTask}
              title="Tài liệu đính kèm"
            />
          )}
        </>
      ),
    },
    {
      key: '3',
      label: 'Danh sách công việc',
      children: (
        <>
          {taskDetail?.contentTask && (
            <MissionDetailWorks
              renderContentOnly
              handleSetTaskDetail={setTaskDetail}
              canAddWork={!!taskDetail.canAddWork}
              missionId={taskCode}
              isDetailList
              works={taskDetail.contentTask?.linkedWork}
            />
          )}
        </>
      ),
    },
    {
      key: 'history-log',
      label: 'Lịch sử',
      children: (
        <div>
          {isLoading && (
            <LoadingOutlined style={{ marginLeft: 10 }} spin={true} />
          )}
          {message && <p>{message}</p>}
          {
            <ul
              style={{
                paddingLeft: 8,
              }}>
              {list &&
                list?.map((item, index) => {
                  // console.log('🚀 ~ ListHistoryLogModal ~ list:', toJS(list))
                  return (
                    <li key={index} style={{ marginBottom: 16 }}>
                      <span style={{ marginBottom: 8, display: 'block' }}>
                        <b>{common_history_log.enumToText(item.action)}</b> lúc
                        <span>
                          {' '}
                          {date_format.HH_mm_DD_MM_YYYY(item.processed_date)}
                        </span>{' '}
                        bởi
                        <b>
                          {' '}
                          {utils.getNameInCapitalize(item.user.name_uppercase)}
                        </b>
                      </span>
                      {/* nếu không có thay đổi(không có data_after) thì không cần hiển thị table */}
                      {item?.data_after && (
                        <DiffTable
                          key={item.id}
                          dataBefore={item.data_before}
                          dataAfter={item.data_after}
                          type="TASK"
                        />
                      )}
                    </li>
                  )
                })}
            </ul>
          }
        </div>
      ),
    },
  ]

  const updateTaskBtn = taskDetail ? (
    <AccessControlAction aclActionType={ACL_ACTION_TYPE.cap_nhat__MISSION}>
      <OverlayPanelWrapper
        renderOverlayPanel={(open, setOpen) => (
          <MissionItemDetailUpdateModalV2
            open={open}
            setOpen={setOpen}
            handleSetTaskDetail={setTaskDetail}
            canUpdateProgress={!!taskDetail?.canUpdateProgress}
            onUpdateSuccess={() => {
              handleGetTaskDetail(taskCode)
              hanhleGetListHistoryLog(taskCode)
            }}
            isDetailList
            missionId={taskCode}
            files={taskDetail?.resultTask?.files || []}
            resultTask={taskDetail?.resultTask}
            contentTask={taskDetail?.contentTask}
            setIsUpdateMissionDetail={setIsUpdateMissionDetail}
            isUpdateMissionDetail={isUpdateMissionDetail}
          />
        )}>
        <Button type="primary">Cập nhật nhiệm vụ</Button>
      </OverlayPanelWrapper>
    </AccessControlAction>
  ) : null

  const content = (
    <Spin spinning={isLoading || isLoadingTaskDetail}>
      <div
        style={{
          marginBottom: 20,
          display: 'flex',
          justifyContent: 'space-between',
          gap: 20,
        }}>
        <h3 style={{ marginBottom: 20, fontSize: 18, fontWeight: 600 }}>
          Thông tin chung
        </h3>
        {showInPageView && updateTaskBtn}
      </div>

      <div
        style={{
          maxHeight: 360,
          overflowY: 'auto',
        }}>
        <TaskInfoListItemStyledV2>
          {taskDetail?.contentTask && (
            <>
              <MissionDetailGeneralInfo contentTask={taskDetail?.contentTask} />
            </>
          )}

          {taskDetail?.resultTask && (
            <MissionDetailUpdate
              missionId={taskCode}
              files={taskDetail.resultTask.files || []}
              resultTask={taskDetail.resultTask}
              contentTask={taskDetail.contentTask}
              setIsUpdateMissionDetail={() => {}}
              isUpdateMissionDetail={false}
              isHideAction={true}
            />
          )}
        </TaskInfoListItemStyledV2>
      </div>

      <Tabs defaultActiveKey="1" items={tabItems} />
      {!showInPageView && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            paddingTop: 16,
            marginTop: 16,
            borderTop: '1px solid #E3E8EF',
          }}>
          {updateTaskBtn}
        </div>
      )}
    </Spin>
  )

  if (showInPageView) {
    return (
      <>
        {!!pageHeader && pageHeader}
        <div className="custom-create-page-content-wrapper">{content}</div>
      </>
    )
  }

  return (
    <Modal
      style={{
        top: 20,
      }}
      title="Chi tiết nhiệm vụ"
      open={open}
      onCancel={() => {
        setOpen(false)
        setTaskDetail(null)
      }}
      footer={null}
      wrapClassName="custom-modal-wrapper"
      width={900}>
      {content}
    </Modal>
  )
}

export default inject(
  'taskStore',
  'authenticationStore',
  'selectPeopleStore',
  'listHistoryLogStore'
)(observer(MissionItemDetailModalV2))
